var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "tile is-child box has-sticky-tile",
      staticStyle: { "margin-bottom": "1rem !important" },
    },
    [
      _c("div", { staticClass: "is-flex is-align-items-center" }, [
        _c(
          "div",
          {
            staticClass:
              "toggle-buttons-vertical ml-2 is-flex is-flex-direction-column",
          },
          [
            _c(
              "span",
              {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: {
                      enabled: true,
                      placement: "right-start",
                      arrow: false,
                      allowHTML: true,
                      theme: "info",
                    },
                    expression:
                      "{ enabled: true, placement: 'right-start', arrow: false, allowHTML: true, theme: 'info' }",
                  },
                ],
                staticClass: "button m-0",
                class: { "is-primary is-selected": _vm.selectedJcni === 0 },
                staticStyle: { "border-radius": "5px 5px 0px 0px" },
                attrs: { content: _vm.tooltipContent0 },
                on: {
                  click: function ($event) {
                    return _vm.changeActive(0)
                  },
                },
              },
              [_c("span", [_vm._v("Jobs Completed Not Invoiced")])]
            ),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: {
                      enabled: true,
                      placement: "right-start",
                      arrow: false,
                      allowHTML: true,
                      theme: "info",
                    },
                    expression:
                      "{ enabled: true, placement: 'right-start', arrow: false, allowHTML: true, theme: 'info' }",
                  },
                ],
                staticClass: "button m-0",
                class: { "is-primary is-selected": _vm.selectedJcni === 2 },
                staticStyle: { "border-radius": "0px 0px 5px 5px" },
                attrs: { content: _vm.tooltipContent2 },
                on: {
                  click: function ($event) {
                    return _vm.changeActive(2)
                  },
                },
              },
              [_c("span", [_vm._v("Past Due Date Audit")])]
            ),
          ]
        ),
        _c(
          "div",
          {
            staticClass:
              "is-flex is-flex-direction-row is-justify-content-space-evenly",
            staticStyle: { width: "100%" },
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "is-flex is-flex-direction-column is-align-items-center",
              },
              [
                _c("span", { staticClass: "header-text-divider" }, [
                  _vm._v("Total Jobs"),
                ]),
                !_vm.isLoading
                  ? _c(
                      "span",
                      { staticClass: "is-size-4 has-text-weight-bold" },
                      [_vm._v(_vm._s(_vm.data.length))]
                    )
                  : _c("div", { staticClass: "spins" }, [
                      _c("span", { staticClass: "mdi mdi-loading" }),
                    ]),
              ]
            ),
            _c(
              "div",
              {
                staticClass:
                  "is-flex is-flex-direction-column is-align-items-center",
              },
              [
                _c("span", { staticClass: "header-text-divider" }, [
                  _vm._v("Job Total "),
                  _vm.includeGst ? _c("span", [_vm._v(" Inc GST ")]) : _vm._e(),
                ]),
                !_vm.isLoading
                  ? _c(
                      "span",
                      { staticClass: "is-size-4 has-text-weight-bold" },
                      [_vm._v(_vm._s(_vm.totalIncGst))]
                    )
                  : _c("div", { staticClass: "spins" }, [
                      _c("span", { staticClass: "mdi mdi-loading" }),
                    ]),
              ]
            ),
            _c(
              "div",
              {
                staticClass:
                  "is-flex is-flex-direction-column is-align-items-center",
              },
              [
                _c("span", { staticClass: "header-text-divider" }, [
                  _vm._v("Debtor Invoice "),
                  _vm.includeGst ? _c("span", [_vm._v(" Inc GST ")]) : _vm._e(),
                ]),
                !_vm.isLoading
                  ? _c(
                      "span",
                      { staticClass: "is-size-4 has-text-weight-bold" },
                      [_vm._v(_vm._s(_vm.debtorInvoice))]
                    )
                  : _c("div", { staticClass: "spins" }, [
                      _c("span", { staticClass: "mdi mdi-loading" }),
                    ]),
              ]
            ),
            _c(
              "div",
              {
                staticClass:
                  "is-flex is-flex-direction-column is-align-items-center",
              },
              [
                _c("span", { staticClass: "header-text-divider" }, [
                  _vm._v("Excess Invoice "),
                  _vm.includeGst ? _c("span", [_vm._v(" Inc GST ")]) : _vm._e(),
                ]),
                !_vm.isLoading
                  ? _c(
                      "span",
                      { staticClass: "is-size-4 has-text-weight-bold" },
                      [_vm._v(_vm._s(_vm.totalExcess))]
                    )
                  : _c("div", { staticClass: "spins" }, [
                      _c("span", { staticClass: "mdi mdi-loading" }),
                    ]),
              ]
            ),
            _c(
              "div",
              {
                staticClass:
                  "is-flex is-flex-direction-column is-align-items-center",
              },
              [
                _c("span", { staticClass: "header-text-divider" }, [
                  _vm._v("Total Not Invoiced "),
                  _vm.includeGst ? _c("span", [_vm._v(" Inc GST ")]) : _vm._e(),
                ]),
                !_vm.isLoading
                  ? _c(
                      "span",
                      { staticClass: "is-size-4 has-text-weight-bold" },
                      [_vm._v(_vm._s(_vm.totalNotInvoiced))]
                    )
                  : _c("div", { staticClass: "spins" }, [
                      _c("span", { staticClass: "mdi mdi-loading" }),
                    ]),
              ]
            ),
          ]
        ),
      ]),
      _c("div", { ref: "jcni0", staticClass: "is-hidden" }, [_vm._m(0)]),
      _c("div", { ref: "jcni1", staticClass: "is-hidden" }, [_vm._m(1)]),
      _c("div", { ref: "jcni2", staticClass: "is-hidden" }, [_vm._m(2)]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "ul",
      { staticStyle: { "list-style-type": "disc", "padding-left": "1rem" } },
      [
        _c("li", [
          _vm._v(
            "Quotes that are in Car Ready, Invoice Pending and Closed job stage"
          ),
        ]),
        _c("li", [_vm._v("Have an outstanding not invoiced amount")]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "ul",
      { staticStyle: { "list-style-type": "disc", "padding-left": "1rem" } },
      [
        _c("li", [
          _vm._v(
            "Quotes that are in Car Ready, Invoice Pending and Closed job stage"
          ),
        ]),
        _c("li", [_vm._v("Are 7 days or more past the Job End date")]),
        _c("li", [_vm._v("Have an outstanding not invoiced amount")]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "ul",
      { staticStyle: { "list-style-type": "disc", "padding-left": "1rem" } },
      [
        _c("li", [
          _vm._v(
            "Identifies booked jobs past their 'Due Out' date that are not yet Completed, Cancelled, or Invoiced."
          ),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }